import type { DoorFrameColorEnum } from './doorframes';
import { RailTrackEnum } from 'CoreAPI/Components/RailTrackEnum';
import { RailTrackTypeEnum } from 'CoreAPI/Components/RailTrackTypeEnum';
import type { RailTypeEnum } from 'CoreAPI/Components/RailTypeEnum';

export const ORIGINAL_RAIL_LENGTH = 2000;
const RAIL_DEPTH_TWO_TRACK = 81;
const RAIL_DEPTH_THREE_TRACK = 122;

const ALL_TRACKS = [
  [
    // Tops
    [
      '30500063--top', // Alu, two track
      '20512641--top', // Black, two track
      '40512640--top' // White, two track
    ],
    [
      '70467085--top', // Alu, three track
      '80512643--top', // Black, three track
      '00512642--top' // White, three track
    ]
  ],
  [
    // Bottoms
    [
      '30500063--bottom', // Alu, two track
      '20512641--bottom', // Black, two track
      '40512640--bottom' // White, two track
    ],
    [
      '70467085--bottom', // Alu, three track
      '80512643--bottom', // Black, three track
      '00512642--bottom' // White, three track
    ]
  ]
];

export const getRailProductRef = (railType: RailTypeEnum, trackType: RailTrackTypeEnum, color: DoorFrameColorEnum) => {
  return ALL_TRACKS[railType][trackType][color];
};

export const isProductARail = (productRef: string) => {
  return ALL_TRACKS.flat(2).some((id) => {
    return id.split('-')[0] === productRef;
  });
};

export const getRailSize = (
  productRef: string
): {
  track: RailTrackTypeEnum;
  color: DoorFrameColorEnum;
} => {
  let trackType: RailTrackTypeEnum = 0;
  let colorType: DoorFrameColorEnum = 0;

  // Top and bottom rail are the same article so we don't need to check for both
  ALL_TRACKS.forEach((rail) => {
    rail.forEach((track, trackIndex) => {
      track.forEach((art, colorIndex) => {
        if (art.split('-')[0] === productRef) {
          trackType = trackIndex;
          colorType = colorIndex;
        }
      });
    });
  });
  return {
    track: trackType,
    color: colorType
  };
};

export const getRailDepth = (trackType: RailTrackTypeEnum) => {
  return trackType === RailTrackTypeEnum.TwoTrack ? RAIL_DEPTH_TWO_TRACK : RAIL_DEPTH_THREE_TRACK;
};

/**
 * Convert index to work for two tracks
 * Useful in some cases where some functions returns an array with only two tracks
 */
export const getRailTrack = (railTrackIndex: RailTrackEnum, trackType: RailTrackTypeEnum) => {
  if (railTrackIndex === RailTrackEnum.Middle && trackType === RailTrackTypeEnum.TwoTrack) {
    return RailTrackEnum.Front;
  }

  return railTrackIndex;
};
